import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslations } from "use-intl";
import { RegistratureResolver } from "../../procedures/[procedureId]/components/resolvers";
interface AddRegistratureDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (registratureId: string) => void;
  institutionId: string;
}
function AddRegistratureDialog({
  isOpen,
  onClose,
  onAdd,
  institutionId
}: AddRegistratureDialogProps) {
  const t = useTranslations();
  const [registratureId, setRegistratureId] = React.useState<string | null>(null);
  const handleSubmit = async () => {
    onAdd(registratureId!);
  };
  return <Dialog open={isOpen} onOpenChange={openStatus => {
    if (!openStatus) {
      onClose();
    }
  }} data-sentry-element="Dialog" data-sentry-component="AddRegistratureDialog" data-sentry-source-file="AddRegistratureDialog.tsx">
      <DialogContent containerClassName="z-50" onInteractOutside={e => {
      e.preventDefault();
    }} className="sm:max-w-[425px]" data-sentry-element="DialogContent" data-sentry-source-file="AddRegistratureDialog.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="AddRegistratureDialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="AddRegistratureDialog.tsx">Adaugă registratură</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RegistratureResolver institutionId={institutionId} isServant={false} onValue={val => "value" in val ? setRegistratureId(val.value) : setRegistratureId(null)} data-sentry-element="RegistratureResolver" data-sentry-source-file="AddRegistratureDialog.tsx" />
        </div>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="AddRegistratureDialog.tsx">
          <Button type="submit" onClick={handleSubmit} data-sentry-element="Button" data-sentry-source-file="AddRegistratureDialog.tsx">
            Salvează
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
}
export default AddRegistratureDialog;